
// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import adminReducer from '../features/admin/adminSlice';
import taskReducer from '../features/tasks/taskSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        admin: adminReducer,
        tasks: taskReducer,
    },
});
